import { render, staticRenderFns } from "./SectionThemeCinderella.vue?vue&type=template&id=dd15d328&scoped=true&"
import script from "./SectionThemeCinderella.vue?vue&type=script&lang=js&"
export * from "./SectionThemeCinderella.vue?vue&type=script&lang=js&"
import style0 from "./SectionThemeCinderella.vue?vue&type=style&index=0&id=dd15d328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd15d328",
  null
  
)

export default component.exports